import styled from 'styled-components'

export const OptionLabel = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;

	> svg {
		flex-shrink: 0;
		width: 20px;
		height: 20px;
	}
`
